import { useMemo, useState } from 'react';

import { GridFilterModel } from '@mui/x-data-grid';
import { GridFilterItem } from '@mui/x-data-grid/models/gridFilterItem';
import { keyBy } from 'lodash';

import { AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGetRequest } from '@sbv-clients/data-access-api';

function assignIfDefined<T, K extends keyof T>(
  output: Partial<T>,
  key: K,
  value: any
) {
  if (value !== undefined) {
    output[key] = value;
  }
}

type FiltersType = Omit<
  AdminFacilityApiAdminFacilityFacilityIdActiveEmployeesGetRequest,
  'facilityId' | 'page' | 'pageSize'
>;

const transformInputToInterface = (input: GridFilterItem[]) => {
  const mapped = keyBy(input, 'field');
  const output: Partial<FiltersType> = {};
  assignIfDefined(output, 'firstName', mapped.firstName?.value);
  assignIfDefined(output, 'lastName', mapped.lastName?.value);
  assignIfDefined(output, 'phone', mapped.phone?.value);
  assignIfDefined(output, 'saasPhone', mapped.saasPhone?.value);
  assignIfDefined(output, 'saasUsername', mapped.saasUsername?.value);
  assignIfDefined(output, 'role', mapped.role?.value);
  assignIfDefined(output, 'saasRole', mapped.saasRole?.value);
  assignIfDefined(output, 'otp', mapped.otp?.value);
  assignIfDefined(output, 'employeeId', mapped.employeeId?.value);
  assignIfDefined(output, 'isRegistered', mapped.isRegistered?.value);
  assignIfDefined(output, 'isOnboarded', mapped.isOnboarded?.value);
  assignIfDefined(
    output,
    'isPhoneNumberConfirmed',
    mapped.isPhoneNumberConfirmed?.value
  );

  return output as FiltersType;
};

export const useFiltersModel = () => {
  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: [],
  });
  const apiFilters = useMemo(
    () => transformInputToInterface(filterModel.items),
    [filterModel]
  );
  return {
    filterModel,
    setFilterModel,
    apiFilters,
  };
};
